import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type GoodsOptionsResponse, goodsService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { isNil } from 'shared/src/utils';

//재입고 알림 신청이 완료되었습니다.
export const usePostRestockNotification = (
  optionSno: number,
  params: {
    depth: number;
    selected_option_sno: number | undefined;
  },
) => {
  const goodsSno = useGoodsSno();

  const client = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      return goodsService.postRestockNotification(optionSno);
    },
    onSuccess: () => {
      client.setQueryData<GoodsOptionsResponse>(
        queryKey.goodsOptions(goodsSno, params),
        oldData => {
          if (isNil(oldData)) return undefined;

          return {
            ...oldData,
            option_components: oldData.option_components.map(component => {
              if (component.goods_option_sno === optionSno) {
                return {
                  ...component,
                  goods_option: component.goods_option
                    ? {
                        ...component.goods_option,
                        is_applied_for_restock: true,
                      }
                    : null,
                };
              }
              return component;
            }),
          };
        },
      );
    },
  });
};
